// Importing necessary libraries
import PropTypes from "prop-types";

// Assuming you have a similar base color setup as in your Settings icon
import colors from "assets/theme/base/colors";

function RecordingSTTIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 -960 960 960"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>recording</title>
      <g fill={colors[color] ? colors[color].main : colors.dark.main}>
        <path d="M680-560q-33 0-56.5-23T600-640v-160q0-34 23.5-57t56.5-23q34 0 57 23t23 57v160q0 34-23 57t-57 23ZM200-80q-33 0-56.5-23.5T120-160v-640q0-33 23.5-56.5T200-880h320v80H200v640h440v-80h80v80q0 33-23.5 56.5T640-80H200Zm80-160v-80h280v80H280Zm0-120v-80h200v80H280Zm440 40h-80v-104q-77-14-128.5-74.5T460-640h80q0 58 41 99t99 41q59 0 99.5-41t40.5-99h80q0 81-51 141.5T720-424v104Z"/>
      </g>
    </svg>
  );
}

// Setting default values for the props of RecordingIcon
RecordingSTTIcon.defaultProps = {
  color: "dark",
  size: "24px", // Adjusted to match your SVG size
};

// Typechecking props for the RecordingIcon
RecordingSTTIcon.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "white",
  ]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default RecordingSTTIcon;
